import React from 'react';
import PropTypes from 'prop-types';

import Group from '../../../../components/Group';
import Column from '../../../../components/Column';
import Label from '../../../../components/Label';
import StorePresenter from '../../../../presenters/StorePresenter';
import { ImageUploader } from '../../../../components';

const Images = (props) => {
  const { errors, brand, onChange } = props;

  const handleLogoUploaded = (image) => {
    onChange('logoImage', image);
  };

  const handleImageUploaded = (image) => {
    onChange('backgroundImage', image);
  };

  const handleMapUploaded = (image) => {
    onChange('locationMap', image);
  };

  return (
    <Group>
      <h3>Images</h3>
      <div className="form-group-fields">
        <Column>
          <div className="input image-upload">
            <Label name="image" title="Logo" errors={errors} />
            <div className="image-upload-hint">
              Image should be a .png with a transparent background
            </div>
            <ImageUploader
              id="logoImage"
              onUploaded={handleLogoUploaded}
              cover
              source={StorePresenter.logoUrl(brand)}
              type="brand"
            />
          </div>
        </Column>

        <Column className="form-group-column">
          <div className="input image-upload">
            <Label name="image" title="Brand Image" errors={errors} />
            <div className="image-upload-hint">
              Image should be a .png or .jpg and have an aspect ratio of 5:2
              (e.g. 750w x 300h)
            </div>
            <ImageUploader
              id="backgroundImage"
              onUploaded={handleImageUploaded}
              cover
              source={StorePresenter.imageUrl(brand)}
              type="brand"
            />
          </div>
        </Column>
      </div>

      <div className="form-group-fields">
        <Column>
          <div className="input image-upload">
            <Label name="image" title="Brand Location Map" errors={errors} />
            <div className="image-upload-hint">
              Image should be a .png or .jpg and have an aspect ratio of 5:2
              (e.g. 750w x 300h)
            </div>
            <ImageUploader
              id="locationMap"
              onUploaded={handleMapUploaded}
              cover
              source={StorePresenter.locationMapUrl(brand)}
              type="brand"
            />
          </div>
        </Column>
      </div>
    </Group>
  );
};

export default Images;

Images.propTyps = {
  errors: PropTypes.shape(),
  onChange: PropTypes.func.isRequired,
  brand: StorePresenter.shape().isRequired,
};

Images.defaultProps = {
  errors: {},
};
